import Axios from 'axios';
import FeatureManager from './feature-manager.class';
import { standard } from './features/standard';
import { apiVersion } from './features/api-version';
import { appToken } from './features/app-token';
import { processFault } from './features/process-fault';
import { userToken } from './features/user-token';
const { create } = Axios;
Axios.create = (config) => {
    const fm = new FeatureManager();
    const axios = create(config);
    const features = {
        use(featureList) {
            featureList.forEach((fe) => fm.push(fe));
            return features;
        }
    };
    features.use(standard());
    axios.features = features;
    axios.interceptors.request.use(fm.reqInterceptor, fm.errInterceptor);
    axios.interceptors.response.use(fm.resInterceptor, fm.errInterceptor);
    return axios;
};
export default Axios;
export { apiVersion, appToken, processFault, userToken };
